import Home from "./Home";
import Cities from "./Cities";
import CityXApp from "./CityX-App";
import CityXAppEditBiz from "./CityX-App-Edit-Business";
import CityXAppNewBiz from "./CityX-App-New-Business";
import CityXTour from "./CityX-Tour";
import CityXTourGuides from "./CityX-Tour-Guides";
import CityXTourMuseums from "./CityX-Tour-Museums";
import CityXTourPromotions from "./CityX-Tour-Promotions";
import Sportter from "./Sportter";

import CityXTeam from "./CityXTeam";
import AboutCarees from "./AboutCarees";
import AboutCareesJobApplication from "./AboutCareesJobApplication";
import AboutStartup from "./AboutStartups";
import AboutRemoteWork from "./AboutRemoteWork";
import AboutGDPR from "./AboutGDPR";
import AboutPrivacyPolicy from "./AboutPrivacyPolicy";
import AboutTerms from "./AboutTerms";

import AboutDetails from "./AboutDetails";

import BlogList from "./BlogList";
import NewsList from "./NewsList";
import News from "./News";

import Contact from "./Contact";

import Partners from "./Partners";
import PartnerAbout from "./PartnerAbout";

/// ADMIN
import Admin_Home from "./_admin/Admin_Home";
import Admin_NewsList from "./_admin/News/Admin_NewsList";
import Admin_EditNews from "./_admin/News/Admin_EditNews";
import Admin_EditCities from "./_admin/Cities/Admin_EditCities";

/// USER
import Login from "./_user/Login";
import Admin_CitiesList from "./_admin/Cities/Admin_CitiesList";

const routes = [
  { path: "/", component: Home },
  { path: "/cities", component: Cities },

  { path: "/apps/cityx-app", component: CityXApp },
  { path: "/apps/cityx-app-edit-biz", component: CityXAppEditBiz },
  { path: "/apps/cityx-app-new-biz", component: CityXAppNewBiz },
  { path: "/apps/cityx-tour-pass", component: CityXTour },
  { path: "/apps/cityx-tour-pass-tourist-guides", component: CityXTourGuides },
  { path: "/apps/cityx-tour-pass-museums", component: CityXTourMuseums },
  {
    path: "/apps/cityx-tour-pass-promotions",
    component: CityXTourPromotions,
  },
  { path: "/apps/sportter", component: Sportter },

  { path: "/blog-list", component: NewsList },
  { path: "/news-list", component: NewsList },
  { path: "/news-list-media", component: NewsList },
  { path: "/news", component: News },
  { path: "/about/cityx-team", component: CityXTeam },
  { path: "/about/carees", component: AboutCarees },
  {
    path: "/about/carees-job-application",
    component: AboutCareesJobApplication,
  },
  { path: "/about-us", component: AboutDetails },
  { path: "/about/startups", component: AboutStartup },
  { path: "/about/remote-work", component: AboutRemoteWork },
  { path: "/about-gdpr", component: AboutGDPR },
  { path: "/about-terms", component: AboutTerms },
  { path: "/about-privacy-policy", component: AboutPrivacyPolicy },

  { path: "/contact", component: Contact },

  { path: "/partners", component: Partners },
  { path: "/partner-about", component: PartnerAbout },

  /// ADMIN
  // { path: "/admin/home", component: Admin_Home, authProtected: true },
  // { path: "/admin/news-list", component: Admin_NewsList, authProtected: true },
  // { path: "/admin/news-edit", component: Admin_EditNews, authProtected: true },
  // {
  //   path: "/admin/cities-list",
  //   component: Admin_CitiesList,
  //   authProtected: true,
  // },
  // {
  //   path: "/admin/cities-edit",
  //   component: Admin_EditCities,
  //   authProtected: true,
  // },

  /// USER
  { path: "/login", component: Login },
];

export default routes;
